"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
var _get = _interopRequireDefault(require("lodash/get"));
var locales = _interopRequireWildcard(require("react-date-range/dist/locale"));
require("react-date-range/dist/styles.css");
require("react-date-range/dist/theme/default.css");
var _ahooks = require("ahooks");
var _styles2 = require("../../shared/styles");
var _styles3 = require("./styles");
var _icons = require("../icons");
var _excluded = ["id", "placeholder", "datePickerProps", "onChange", "isError", "colorType", "value", "margin", "marginBottom", "locale", "icon"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var DatePicker = function DatePicker(_ref) {
  var id = _ref.id,
    placeholder = _ref.placeholder,
    datePickerProps = _ref.datePickerProps,
    onChange = _ref.onChange,
    isError = _ref.isError,
    colorType = _ref.colorType,
    value = _ref.value,
    margin = _ref.margin,
    marginBottom = _ref.marginBottom,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? (navigator.language || navigator.userLanguage).substr(0, 2) : _ref$locale,
    icon = _ref.icon,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useToggle = (0, _ahooks.useToggle)(null),
    _useToggle2 = _slicedToArray(_useToggle, 2),
    calendarVisible = _useToggle2[0],
    _useToggle2$ = _useToggle2[1],
    showCalendar = _useToggle2$.toggle,
    hideCalendar = _useToggle2$.setLeft;
  var dateFormat = new Intl.DateTimeFormat(locale, {
    dateStyle: 'short'
  });
  var handleOnChange = function handleOnChange(item) {
    if ((0, _isFunction["default"])(onChange)) {
      onChange(item);
    }
    hideCalendar();
  };
  var calendarRef = (0, _react.useRef)();
  (0, _ahooks.useClickAway)(function () {
    hideCalendar();
  }, calendarRef);
  var top = (0, _get["default"])(calendarRef, 'current.offsetTop') > 330;
  return /*#__PURE__*/_react["default"].createElement(_styles3.Wrapper, {
    ref: calendarRef,
    colorType: colorType,
    margin: margin,
    marginBottom: marginBottom
  }, /*#__PURE__*/_react["default"].createElement(_styles3.HiddenInput, _extends({
    type: "date",
    id: id
  }, rest)), /*#__PURE__*/_react["default"].createElement(_styles3.Date, {
    onClick: function onClick() {
      return showCalendar();
    },
    isError: isError,
    colorType: colorType,
    date: value
  }, /*#__PURE__*/_react["default"].createElement(_styles3.DateWrapper, null, value ? dateFormat.format(value) : placeholder), /*#__PURE__*/_react["default"].createElement(_styles3.IconWrapper, {
    colorType: colorType
  }, icon || /*#__PURE__*/_react["default"].createElement(_icons.Calendar, {
    width: 22,
    height: 22
  }))), calendarVisible && /*#__PURE__*/_react["default"].createElement(_styles3.CalendarStyle, _extends({
    top: top,
    onChange: handleOnChange,
    date: value,
    color: _styles2.color.orange,
    locale: locales[locale],
    colorType: colorType
  }, datePickerProps)));
};
DatePicker.propTypes = {
  id: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  colorType: _propTypes["default"].string,
  locale: _propTypes["default"].string,
  datePickerProps: _propTypes["default"].object,
  onChange: _propTypes["default"].func,
  isError: _propTypes["default"].bool,
  value: _propTypes["default"].object,
  margin: _propTypes["default"].object,
  marginBottom: _propTypes["default"].string,
  icon: _propTypes["default"].node
};
var _default = DatePicker;
exports["default"] = _default;